import { Component } from '@angular/core';
import { ICONS } from 'src/app/core/constants/icons';
import { ROUTES } from 'src/app/core/constants/routes';

@Component({
  selector: 'app-recovery-confirmation',
  templateUrl: './recovery-confirmation.component.html',
  styleUrls: ['./recovery-confirmation.component.scss']
})
export class RecoveryConfirmationComponent {
  LOGO = ICONS.LOGO;
  LOGIN_ROUTE = ROUTES.LOGIN;
}
